<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createDocument') }}</h1>
      <div class="form-container">
        <DocumentForm @save="save"></DocumentForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import DocumentForm from '@/components/DocumentForm'

  export default {
    components: {
      DashboardLayout,
      DocumentForm
    },
    methods: {
      save(documentForm) {
        this.$store.dispatch('Document/create', documentForm).then(document => {
          this.$router.push({
            name: 'documentDetail',
            params: {documentId: document.id}
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Document/getRelations')
    },
    computed: {
      breadcrumbs() {
        return [
          { name: 'documents', path: 'documents' },
          { name: 'createDocument' }
        ]
      }
    }
  }
</script>
